import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useDispatch } from 'react-redux';
import { WATCH_USER } from '../../../redux/actionTypes';
import AuthService from '../../../services/auth.service';

const GoogleLoginButton = ({ onLoginError }) => {
  const dispatch = useDispatch();

  const handleSuccess = async (credentialResponse) => {
    const success = await AuthService.loginWithGoogle(credentialResponse.credential);
    if (success) {
      dispatch({ type: WATCH_USER });
    } else {
      if (onLoginError) onLoginError();
    }
  };

  const handleError = () => {
    console.error('Error en el inicio de sesión con Google');
    if (onLoginError) onLoginError();
  };

  return <GoogleLogin
    onSuccess={handleSuccess}
    onError={handleError}
    useOneTap
    text="signin_with"
    shape="rectangular"
    size={'large'}
  />;
};

export default GoogleLoginButton; 